var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageContainer',{staticClass:"has-tabs"},[_c('template',{slot:"title"},[_c('pageTitle',{attrs:{"pageTitle":_vm.$t('lang.k_348001')}})],1),_c('template',{slot:"content"},[_c('ComplianceRisk')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }